var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInboxFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.928 13.328H12.08a.45.45 0 0 0-.447.462c0 .26.195.462.447.462h7.847c.252 0 .438-.202.438-.462s-.186-.462-.438-.462zm1.231 2.176H10.841c-.262 0-.458.24-.458.5s.196.482.458.482h10.318c.262 0 .467-.221.467-.481s-.205-.501-.467-.501z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93 27h16.14c1.96 0 2.93-1.001 2.93-2.985V18.7c0-.866-.13-1.27-.532-1.829l-3.219-5.06C22.232 10.375 21.673 10 20.012 10h-8.024c-1.66 0-2.211.376-3.228 1.81l-3.228 5.061c-.392.559-.532.963-.532 1.83v5.314C5 26.008 5.98 27 7.93 27zM16 21.425c-1.4 0-2.295-1.252-2.295-2.436v-.029c0-.433-.252-.837-.775-.837H6.987c-.308 0-.373-.27-.224-.482l3.452-5.455c.43-.617.98-.838 1.661-.838h8.248c.681 0 1.231.221 1.66.838l3.452 5.455c.14.212.085.482-.223.482H19.07c-.523 0-.765.404-.765.837v.03c0 1.184-.896 2.435-2.305 2.435z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxFilled);
export default __webpack_public_path__ + "static/media/Inbox_Filled.c180f7423bbbcecf43fc1a11f44c1f87.svg";
export { ForwardRef as ReactComponent };